import { Tooltip } from "antd";
import React from "react";

interface TruncateStringProps {
  str: string | null | undefined;
  maxLength?: number;
  increaseTooltipWidth?: boolean;
  isHTML?: boolean;
  className?: string;
  isTooltip?: boolean; // Add isTooltip prop
}

export const TruncateString: React.FC<TruncateStringProps> = ({
  str,
  maxLength = 25,
  increaseTooltipWidth = false,
  isHTML = false,
  className,
  isTooltip = true, // Default to true if isTooltip prop is not provided
}) => {
  const isLongStr = str && str.length > 1000;

  if (str && str.length > maxLength) {
    const truncated = str.slice(0, maxLength) + "...";
    const title = isHTML ? (
      <span dangerouslySetInnerHTML={{ __html: str }} />
    ) : (
      str
    );

    return (
      <>
        {isTooltip ? (
          <Tooltip
            title={isHTML ? title : str}
            overlayStyle={{
              ...(isLongStr && increaseTooltipWidth
                ? { maxWidth: "800px", maxHeight: "500px", overflow: "scroll" }
                : {}),
            }} // Combine styles
          >
            {isHTML ? (
              <span
                className={className}
                dangerouslySetInnerHTML={{ __html: truncated }}
              />
            ) : (
              <span className={className}>{truncated}</span>
            )}
          </Tooltip>
        ) : (
          <span className={className}>{isHTML ? title : truncated}</span>
        )}
      </>
    );
  } else {
    return <span className={className}>{str}</span>;
  }
};
